import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "action";
const pathData = "M416 319h32v129q0 13-9 22.5t-23 9.5H32q-13 0-22.5-9.5T0 448V64q0-14 9.5-23T32 32h128v32H32v384h384V319zm87-229q9 10 9 23t-9 23l-92 84q-5 5-11 5t-11-5-5-11.5 5-11.5l75-69h-48q-40 0-75 15t-61 41.5-41 61.5-15 74v16q0 16-16 16t-16-16v-18.5l1-4.5q1-45 19.5-84.5T261 160t70-46 85-17h48l-75-69q-5-5-5-11.5T389 5t11-5 11 5z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v4";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v4/action";
export { pathData, ltr, accData };